const IS_GMP = process.env.VUE_APP_ENV === "GMP";

module.exports = { IS_GMP };
